module.exports = __webpack_public_path__ + "img/nt-back.ac53c2f8.png";